"use client";

import React from "react";
import type { MapSearchAutocompleteProps } from "modules/common/components/map/MapSearchAutocomplete";
import MapSearchAutocompleteSkeleton from "modules/common/components/skeletons/map/MapSearchAutocompleteSkeleton";
import dynamic from "next/dynamic";

// Create dynamic component once at module level — never inside a component body
const MapSearchAutocompleteLazy = dynamic(
  () => import("modules/common/components/map/MapSearchAutocomplete"),
  {
    loading: () => <MapSearchAutocompleteSkeleton />,
    ssr: false,
  }
);

const RenderMapSearchAutocomplete = ({
  className,
  ...props
}: MapSearchAutocompleteProps) => {
  return (
    <div className={className}>
      <MapSearchAutocompleteLazy {...props} />
    </div>
  );
};

export default RenderMapSearchAutocomplete;
